<template>
    <div class="products-view__options view-options view-options--offcanvas--mobile">
        <div class="view-options__body" v-if="searchTerm != undefined">
            <!-- <div class="view-options__legend">
                <strong>Search Term: </strong>
                <span>{{search_term}} </span>
            </div> -->
            <div class="view-options__spring"></div>
            <div class="view-options__legend" >
                Showing {{total_results}} products
            </div>
        </div>
        <div class="view-options__body">
            <button class="btn btn-small btn-dark-grey btn-check-stock" v-if="searchTerm == undefined && showBtn" @click="toggle_smart_section">Show/Hide Diagram</button>
            <div class="container-form-button" v-if="pageName == 'SearchResults'">																
                <router-link to="/select-parts-drilldown" class="btn btn-sm btn-gold">New {{catclass}} Product Search</router-link>
            </div>
            <!-- removed class : view-options__legend -->
            <div class="view-options__legend" v-if="pageName == 'SearchResults'">                
                <span  v-if="search_term != ''"><strong>Selected Term:</strong> {{ search_term }}</span>
                <span v-else><strong >Selected Category or Search Term:</strong> {{ search_categories }}</span>
            </div>
            <div class="view-options__layout layout-switcher">
                <div class="layout-switcher__list">                                                        
                    <button type="button" class="layout-switcher__button layout-switcher__button--active" data-layout="table" data-with-features="false">
                    </button>
                </div>
            </div>
            
            <div class="view-options__legend" v-if="searchTerm != '' && searchTerm != undefined">
                <strong>Search Term:</strong> {{ searchTerm }} <span>({{total_results}} results)</span>
            </div>
            <div class="view-options__spring"></div>
            <div class="exhaust-diagram-filters" v-if="total_results > 0">
                <div class="view-options__select" v-if="showFilterAvailable === true">
                    <label for="view-option-sort">Availability:</label>
                    <select id="view-option-sort" class="form-control form-control-sm" v-model="filter_availability" name="" @change="filterAvailability">
                        <option value="InStock">In Stock</option>
                        <option value="All" selected="selected">All Items</option>	                                
                    </select>
                </div> 

                <div class="view-options__select">
                    <label for="view-option-sort">Price:</label>
                    <select id="view-option-sort" class="form-control form-control-sm" name="" v-model="filter_price" @change="filterPrice">
                        <option value="">Select</option>
                        <option value="LowToHigh">Low to High</option>
                        <option value="HighToLow">High to Low</option>	                                
                    </select>
                </div>  
            </div>
        </div>

        <div class="view-options__body view-options__body--filters"  v-if="searchTerm != undefined">
            <div class="view-options__label">Active Filters</div>
            <div class="applied-filters">
                <ul class="applied-filters__list">
                    <li class="applied-filters__item" v-for="(f, i) in filters" :key="i" >
                        <a href="#" class="applied-filters__button applied-filters__button--filter" @click="removeFilter(i, f)">
                            {{f[0]}}: {{ f[1] }}
                            <svg width="9" height="9">
                                <path d="M9,8.5L8.5,9l-4-4l-4,4L0,8.5l4-4l-4-4L0.5,0l4,4l4-4L9,0.5l-4,4L9,8.5z" />
                            </svg>
                        </a>
                    </li>
                    <li class="applied-filters__item" v-if="filters.length > 0" @click="clearAll">
                        <button type="button" class="applied-filters__button applied-filters__button--clear">Clear All</button>
                    </li>
                </ul>
            </div>
        </div>
    </div>

</template>

<script>
import { mapGetters } from 'vuex';

    export default {
        computed: {
            ...mapGetters("vehicle", [
                "industry_sels",
            ]),
            ...mapGetters('api', [
                "catclass",
            ]),
            search_categories() {
                const categories = [];
                this.industry_sels.forEach(i => {
                    categories.push(i[1]);
                });
                const joinCat = categories.join(', ');

                return joinCat;
            },

            hasFilter() {
                const newFilters = [];
                for (const property in this.filters) {
                    if(this.filters[property].length > 0){
                        newFilters.push([property, this.filters[property]]);
                    }
                }
                return newFilters;
            },

            search_term() {
                let search_keyword = '';

                if (this.$route.name == 'SearchResults'){
                    search_keyword = this.keyword;
                }else{
                    const categories = [];
                    this.industry_sels.forEach(i => {
                        categories.push(i[1]);
                    });
                    const joinCat = categories.join(', ');

                    search_keyword = joinCat;
                }

                // console.log('search_keyword = ' + search_keyword);
                return search_keyword;
            }
        },
        watch: {
            searchTerm(newVal) {
                console.log(newVal);
                this.filters = [];
            }
        },
        data() {
            return {
                show_smart_section: false,
                filter_price: 'LowToHigh',
                filter_availability: 'All',
                showBtn: this.hasSmart,
                showFilterAvailable: false,

                filters: [],
                pageName: '',
            }
        },
        props: {
            hasSmart: {
                type: Boolean
            },
            searchTerm: {
                type: String
            },
            total_results : {
                type: Number,
                required: true,
            },
            keyword: {
                type: String,
            },
            currentPage: {
                type: String,
            }
        },

        methods: {
            filter_changed(selected_filters, orig_facets) {
                const categories = this.$store.getters['product/categories'];
                const code1 = this.$route.params.categoryUri;
                let code2 = '';
                let cat2details = '';
                this.filters = [];
                for (const property in selected_filters) {
                    if(selected_filters[property].length > 0){
                        // console.log(property);
                        // console.log(selected_filters[property]);
                        let vals = [];
                        let val = '';
                        let gap = 0;
                        switch(property){
                            case 'Available':
                                continue;
                            case 'Weights':
                                vals = [];
                                gap = orig_facets.facet_ranges.Weight.gap;
                                selected_filters[property].forEach(v => {
                                    vals.push(v + ' - ' + (parseFloat(v) + parseFloat(gap)))
                                });
                                if(vals.length > 1){
                                    val = 'Multiple';
                                }else{
                                    val = vals[0];
                                }
                                this.filters.push([property, val]);

                                break;
                            case 'Prices':
                                vals = [];
                                gap = orig_facets.facet_ranges.B2C_price.gap;
                                selected_filters[property].forEach(v => {
                                    vals.push('$' + v + ' - $' + (parseFloat(v) + parseFloat(gap)))
                                });
                                if(vals.length > 1){
                                    val = 'Multiple';
                                }else{
                                    val = vals[0];
                                }
                                this.filters.push([property, val]);
                                break;
                            case 'PartTypes':
                                vals = [];
                                // gap = orig_facets.facet_ranges.B2C_price.gap;
                                selected_filters[property].forEach(v => {
                                    vals.push(v);
                                });

                                if(vals.length > 1){
                                    val = 'Multiple';
                                }else{
                                    val = vals[0];
                                }
                                // console.log(vals);/
                                this.filters.push([property, val]);
                                break;
                            case 'Category':
                                code2 = selected_filters[property];
                                cat2details = categories.find((cat) => ((cat.DMCD01 === code1) && (cat.DMCD02 === code2) && (cat.categorylevel === 2)));
                                this.filters.push([property, cat2details.categoryname]);
                                break;
                            case 'Stocks':
                                if (selected_filters[property] == 'Y'){
                                    this.filters.push([property, 'Stocked Items']);
                                }else{
                                    this.filters.push([property, 'All Stocked Parts']);
                                }
                                break;
                            case 'Brands':
                                vals = [];
                                // gap = orig_facets.facet_ranges.B2C_price.gap;
                                selected_filters[property].forEach(v => {
                                    vals.push(v);
                                });
                                if(vals.length > 1){
                                    val = 'Multiple';
                                }else{
                                    val = vals[0];
                                }
                                this.filters.push([property, val]);
                                break;
                            default:
                                vals = [];
                                selected_filters[property].forEach(v => {
                                    vals.push(v);
                                });
                                if(vals.length > 1){
                                    val = 'Multiple';
                                }else{
                                    val = vals[0];
                                }

                                this.filters.push([property, val]);
                            break;

                        }
                    }
                }

                // console.log(this.filters);
            },

            removeFilter(i, filter) {
                // console.log(filter);
                this.filters.splice(i, 1);

                this.$emit('removeFilter', filter);
            },

            clearAll(){
                this.filters = [];
                this.$emit('clearAll');
            },
            toggle_smart_section() {
                this.show_smart_section = !this.show_smart_section;
                this.$emit('toggleSmartSection', this.show_smart_section);
            },
            perPageChanged(perPage){
                // console.log(perPage);
                this.$emit('changePerPage', perPage);
            },
            filterPrice() {
                this.$emit('filterPrice', this.filter_price);
            },
            filterAvailability() {
                this.$emit('filterAvailability', this.filter_availability);
            },
            toggleShowBtn(){
                this.showBtn = true;
            }
        },
        created() {
            // console.log('PAGE NAME = ' + this.$route.name);
            this.pageName = this.$route.name;   
            if(this.currentPage == 'SearchResults'){
                this.filter_price = 'LowToHigh';
                this.filter_availability = 'All';
                this.showFilterAvailable = true;
            }else{
                this.filter_price = '';
                this.filter_availability = '';
                this.showFilterAvailable = false;
            }
        },
        updated() {
            // console.log('this.searchTerm = ' + this.searchTerm);
            // console.log('this.hasSmart = ' + this.hasSmart);
            
            // console.log(this.industry_sels);
        }
    }
</script>